import axios from 'axios';
import { message } from 'antd';
import Mock from './mock'
import DataControl from '@/data-control'
import { BASE_URL, TIMEOUT } from "./config";

const isError = e => Object.prototype.toString.call(e) === '[object Error]'

const ERROR_CODE = {
    TIMEOUT_ERROR: {
        code: -101,
        text: 'request timeout'
    },
    NETWORK_ERROR: {
        code: -102,
        text: 'network error'
    },
    UNKNOWN_ERROR: {
        code: -103,
        text: 'unknown error'
    },
    HTTP_STATUS_ERROR: {
        text: 'http status is not between 200 and 299'
    }
}

const instance = axios.create({
    baseURL: BASE_URL,
    timeout: TIMEOUT,
    headers: {
        'Content-Type': 'application/json; charset=utf-8',

    }

});

// 所有请求的统一拦截
instance.interceptors.request.use(config => {
    const loginInfo = DataControl.getCacheLoginInfo()
    if (loginInfo && loginInfo.token) {
        config.headers.Authorization = loginInfo.token
    }
    return config;
}, err => {
    return err
});

// 所有返回的统一拦截
instance.interceptors.response.use((res) => {
    return res.data;
}, (err) => {
    if (err?.response?.status === 401) {
        DataControl.clearCacheLoginInfo()
        setTimeout(() => {
            window.location.href = `/login?redirect_url=${window.encodeURIComponent(window.location.href)}`;
        }, 1000);
    }
    return err;
});


/**
 * axios.get(url[, config])
 * axios.delete(url[, config])
 * axios.head(url[, config])
 * axios.options(url[, config])
 * axios.post(url[, data[, config]])
 * axios.put(url[, data[, config]])
 * axios.patch(url[, data[, config]])
 * 统一处理公共参数（mock、showLoading等）
 * @param ins
 * @returns {*}
 * 使用方式 ：
 *  ins.get(url,data,config)
 *  ins.post(url,data,config)
 */
function enhanceAxios(ins) {
    const postMethod = ['post', 'put', 'patch']
    const getMethod = ['get', 'delete', 'head', 'options']
    postMethod.concat(getMethod).forEach(method => {
        ins[`ori_${method}`] = ins[method];
        ins[method] = async function (...args) {
            let retJson = null, hideLoading = null;

            const [url, params, extendConfig = {}] = args
            let config = {
                url,
                method
            }
            if (postMethod.includes(method)) {
                config.data = params
            } else {
                config.params = params
            }

            const { showLoading = true, useMock, reqInterceptor, resInterceptor } = extendConfig

            // 1、添加request拦截器
            if (reqInterceptor) {
                config = reqInterceptor(config);
            }

            // 2、处理loading
            if (showLoading) {
                if (typeof showLoading === 'function') {
                    hideLoading = showLoading();
                    if (typeof hideLoading !== 'function') {
                        throw new TypeError('showLoading为函数时，需返回一个hideLoading的函数')
                    }
                } else {
                    hideLoading = DataControl.showLoading()
                }
            }

            try {
                if (useMock) {
                    retJson = await Mock.exec(`${BASE_URL}${url}`, method)
                } else {
                    retJson = await ins.request(config)
                }
                const { code, msg } = retJson
                if (code !== 0) {
                    message.error(msg || 'code不为0')
                    retJson = {
                        error: true
                    }
                } else {

                    if (resInterceptor) {
                        retJson = resInterceptor(retJson)
                    }
                }

            } catch (e) {
                message.error(e.message)
                retJson = {
                    error: true
                }
            }
            hideLoading && hideLoading();
            return retJson

        }
    })
    return ins
}


export default enhanceAxios(instance);


